export let razorpayKey;

if (process.env.NODE_ENV === 'production') {
  razorpayKey = 'rzp_test_GgcYUzjZKPkPtK';
} else {
  razorpayKey = 'rzp_test_GgcYUzjZKPkPtK';
}
